import React from "react";
import "../styles/searchBar.scss";
import SearchIcon from "../icons/SearchDuo.svg";

const SearchBar = ({ value, onChange }) => {
  return (
    <div className="search-bar-select">
      <img src={SearchIcon} alt="Serch bar" />
      <input
        type="text"
        placeholder="Search"
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default SearchBar;
